export default __webpack_public_path__ + "static/media/SlideNotesLogo.893cf292.png";